@let isMobile = deviceService.isMobile();
@let itemTmpl = itemTemplate();

<p-multiSelect
  #multiSelect
  class="token-wrap h--40 text-14 {{ styleClass() }}"
  [ngModel]="value()"
  [disabled]="isDisabled()"
  [options]="options()"
  [appendTo]="'body'"
  [maxSelectedLabels]="maxSelectedLabels()"
  [placeholder]="placeholder() || ('alerts.set-up.select-geofence' | translate)"
  [filterPlaceHolder]="filterPlaceHolder() || ('button.search' | translate)"
  [filter]="filter()"
  [optionLabel]="optionLabel()"
  [optionValue]="optionValue()"
  [dataKey]="dataKey()"
  [display]="display()"
  [displaySelectedLabel]="displaySelectedLabel()"
  [chipIcon]="'pi pi-times'"
  [showClear]="showClear()"
  [focusOnHover]="focusOnHover()"
  [showHeader]="showHeader()"
  [selectedItemsLabel]="'common.n-selected' | translate: { value: value().length }"
  [emptyMessage]="'common.no-results' | translate"
  [emptyFilterMessage]="'common.no-results' | translate"
  [panelStyleClass]="isMobile ? 'hidden' : ''"
  [pt]="multiSelectPt"
  (click)="isMobile && onMobileOpen()"
  (onPanelShow)="isMobile && closePrimePanel()"
  (ngModelChange)="updateValue($event)"
>
  <!-- PrimeNG also uses this template in comma mode, so it must only exist for chips -->
  @if (display() === 'chip') {
    <ng-template #selecteditems let-removeChip="removeChip">
      <!-- Tracked by value: a removed p-chip hides itself, so a reused instance would stay hidden -->
      @for (item of visibleChips(); track item) {
        <div class="p-multiselect-chip-item">
          <p-chip
            class="p-multiselect-chip"
            [label]="multiSelect.getLabelByValue(item)"
            [removable]="!isDisabled()"
            [removeIcon]="'pi pi-times'"
            (onRemove)="removeChip(item, $event)"
          ></p-chip>
        </div>
      }
      @if (hiddenChipsCount()) {
        <div class="p-multiselect-chip-item">
          <p-chip class="p-multiselect-chip" [label]="'+' + hiddenChipsCount()"></p-chip>
        </div>
      }
    </ng-template>
  }
  @if (itemTmpl) {
    <ng-template #item let-option>
      <ng-container
        [ngTemplateOutlet]="itemTmpl"
        [ngTemplateOutletContext]="{ $implicit: option }"
      ></ng-container>
    </ng-template>
  }
</p-multiSelect>

<app-bottom-dialog [visible]="visible()" (visibleChange)="onVisibleChange($event)">
  <div class="content" [class.searchable]="filter() && options().length > SHORT_LIST_SIZE">
    @if (mobilePanelTitle()) {
      <div class="text-18 fw-600 color-gray-900 mb-16">{{ mobilePanelTitle() }}</div>
    }
    <div class="list">
      @if (filter()) {
        <header>
          <p-checkbox
            [binary]="true"
            [ngModel]="isAllSelected()"
            (ngModelChange)="toggleAll($event)"
          ></p-checkbox>
          <p-iconfield class="w100">
            <input
              pInputText
              type="text"
              class="h--40 w100"
              autocomplete="off"
              autocorrect="off"
              spellcheck="false"
              [placeholder]="filterPlaceHolder() || ('button.search' | translate)"
              [ngModel]="searchQuery()"
              (ngModelChange)="searchQuery.set($event)"
            />
            <p-inputicon>
              <app-icon-search
                [width]="20"
                [height]="20"
                [color]="'var(--color-gray-500)'"
              ></app-icon-search>
            </p-inputicon>
          </p-iconfield>
        </header>
      }

      <div class="scroll-wrapper scrollbar-gray">
        @for (option of filteredOptions(); track $index) {
          @let optionSelected = isOptionSelected(option);
          @let optionDisabled = isOptionDisabled(option);

          <div
            class="option-item"
            [class.selected]="optionSelected"
            [class.disabled]="optionDisabled"
            (click)="toggleOption(option)"
          >
            <p-checkbox
              [binary]="true"
              [readonly]="true"
              [disabled]="optionDisabled"
              [ngModel]="optionSelected"
            ></p-checkbox>
            @if (itemTmpl) {
              <ng-container
                [ngTemplateOutlet]="itemTmpl"
                [ngTemplateOutletContext]="{ $implicit: option }"
              ></ng-container>
            } @else {
              <div class="text">{{ getOptionLabel(option) }}</div>
            }
          </div>
        } @empty {
          <div class="option-item text">{{ 'common.no-results' | translate }}</div>
        }
      </div>
    </div>
    <footer class="flex gap-12 mt-16">
      <p-button class="h--40 text-14 fw-600 w50" [severity]="'secondary'" (click)="cancelValue()">
        {{ 'button.cancel' | translate }}
      </p-button>
      <p-button class="h--40 text-14 fw-600 w50" (click)="applyValue()">
        {{ 'button.apply' | translate }}
      </p-button>
    </footer>
  </div>
</app-bottom-dialog>
